module.exports = ".row{\r\n    padding:20px 0px 0px;\r\n}\r\n\r\n.row:nth-child(odd){\r\n    background: #f2f2f2;\r\n}\r\n\r\n.mandatory{\r\n    color:red;\r\n}\r\n\r\n.border-box{\r\n    margin: 24px 0px 0px 0px;\r\n    border: 1px solid gray;\r\n    padding: 4px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/landprocurement/land-payment/landpayment-form/landpayment-form.component.css
// module id = ./src/app/landprocurement/land-payment/landpayment-form/landpayment-form.component.css
// module chunks = main